import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {TradeIdeasViewModel} from "../../../models/TradeIdeasViewModel";
import {IronCondorIdeaInfoDialog} from "../iron-condor/dialog/IronCondorIdeaInfoDialogComponent";
import {isIronCondorIdea} from "../../../models/TradeIdeaRecord";

export class IdeaInfoDialogService {

    public static id = "ideaInfoDialogService";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {
    }

    public open(model: TradeIdeasViewModel): Promise<void> {

        if (isIronCondorIdea(model.idea)) {
            return this.showIronCondorInfo(model);
        }

        return Promise.resolve();
    }

    private async showIronCondorInfo(model: TradeIdeasViewModel): Promise<void> {
        const options: IModalSettings = {
            component: IronCondorIdeaInfoDialog,
            controllerAs: "ctrl",
            size: "md",
            resolve: {
                model: () => model
            }
        };
        const modal = this.$uibModal.open(options);
        return await modal.result;
    }
}
